import { MapType, RegionSetting } from './models';

export const stalkitServerUrl =
  'https://core.dev.stalkit.net/core-api-dev/api/v1';
export const testDeviceGroupPublicIdentifier =
  '30f87d5a-bcc2-4f3c-9c04-0f1469d4a211';
export const filterPositionDays = 4;
export const emailValidationEnabled = true;
export const esriGeodataToken =
  'H_V9sTjl4cKffp_m3CdkVVAmAZdsJZRPIomtEibTvkfy9EHFdr58S72hsbOP9XrK1V38--jF4cUJkVHIMaIr2GnpnzQFDtfifc99jX21dB5qyaA-A2Q1uAVhw-8csL2J';

export const cacheSettings = {
  limit: 20,
  maxAgeSeconds: 600,
};

// Used to automatically determine the unit of a series of weights.
export const autoWeightUnitSettings = {
  bound: 10,
  treshold: 0.5,
};
export const autoRefreshInterval = 60 * 1000;
export const reportsGridPageSize = 20;
export const reportsContactMailto = 'support@fieldata.no';

export const orderDetailsGridPageSize = 30;

export const defaultAnimatedNumberAnimationDuration = 1;

export const analyticsCode = 'UA-XXXXXX-X';

export const selectedRegion = RegionSetting.Europe; //0 = Norway, 1 = Europe

export const serviceUrls = {
  baseUrl: '/api',
  trackingLatest: '/tracking/latest',
  devices: '/device',
  stalkitAuth: '/stalkitAuth',
  geodataToken: '/geodataToken',
};

export const wasteManagementUrls = {
  baseUrl: 'https://wmrestapi-test.azurewebsites.net/api/v1',
  orders: '/orders',
  serviceOrders: '/serviceOrders',
  serviceLists: '/serviceLists',
  containerOrders: '/containerOrders',
  route: '/routes',
  dataButtons: 'userSettings/dataButtons',
  visibleFields: 'userSettings/visibleFields',
  detailDataConfiguration: 'userSettings/detailDataConfiguration',
  users: '/users',
  customers: '/customers',
  modules: '/modules',
  contractors: '/contractors',
  auth: '/auth',
  auth0Auth: '/auth/auth0',
  logout: '/auth/logout',
  reports: '/reports',
  agreements: '/agreements',
  depots: '/depots',
  routeAnalysis: '/routeAnalysis',
  routes: '/routes',
  vehicles: {
    base: '/vehicles',
    positions: '/vehicles/positions',
    all: '/vehicles/all',
    settingTemplates: '/vehicles/settings',
    settings: '/settings',
    bulkSettings: '/settings/bulk',
  },
  deviations: {
    base: '/deviations',
  },
  fractions: '/fractions',
  message: '/message',
  units: '/units',
  genericMap: '/genericMap',
  orderExclusion: '/orderExclusion',
};

export const mapServiceUrls = {
  baseUrl: 'https://tracklog-mapservices.azurewebsites.net/api/v1',
  wms: 'https://wms.gisline.no/wms-stavanger',
};

export const pictureStorageUrl =
  'https://dtauniversalstorage.blob.core.windows.net/shared-resources/Fractions/';

export const mapServiceSettings = {
  trackingLinesRequestCacheInMilliseconds: 60 * 1000,
  maxSegmentLengthMeters: 150,
  trackingLineDebugPopupsEnabled: true,
  trackingLineProdPopupsEnabled: false,
  maxTrackInfoLinePointDistance: 150,
  minTrackInfoLinePointDistance: 1,
};

export const mapSettings = {
  mapType: MapType.UTM33N, //WGS84, UTM33N
  objectColoring: {
    default: 'gray',
    firstInterval: '#00dc00',
    secondInterval: '#0000dc',
    thirdInterval: '#fffb00',
    fourthInterval: '#dc0000',
  },
};

export const auth0Config = {
  domain: 'fieldata-test.eu.auth0.com',
  clientId: 'Wj8hnALpxLVTZ7aYFEhnnitINOQlVNz1',
  audience: 'https://webservices-test.fieldata.no',
};

export const smartMapZoomLimit = 13;
